import { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { setProjectVType } from "../../reducers/ViewTypeSlice";
import { FlexBox, HintTooltip } from "@brg/ui";
import { useTranslation } from "react-i18next";
import ViewTypeWide from "../../assets/32/ViewTypeWide";
import { AppTester } from "supporting";

export enum LongreadViewType {
  fluid = 'fluid',
  fluidWide = 'fluid-wide',
  container = "container",
  shadow = "shadow",
}

interface ILRSwitcher {
  vtype?: LongreadViewType;
  currentVType?: LongreadViewType;
  onWhiteBg?: boolean;
}

const LRSwitcherFill = styled.div<ILRSwitcher>`
  cursor: pointer;
  transition: 0.1s;
  //:not(:last-child) {
  //  margin-right: 24px;
  //}
  
  :hover {
    filter: ${({onWhiteBg}) => (!onWhiteBg ? 'brightness(0) invert(1)' : 'brightness(0)')};
  }
  
  filter: ${({ currentVType, vtype, onWhiteBg }) => currentVType === vtype ? (!onWhiteBg ? 'brightness(0) invert(1)' : 'brightness(0)') : 'initial'};
`;

const ViewTypeControllerRoot = styled(FlexBox)`
  height: 100%;
  align-items: center;
  @media (max-width: 2000px) {
    display: none;
  }
`;

const ViewTypeControllerWide = () => {
  const dispatch = useDispatch();
  const vtype = useSelector((state: any) => state.vt.projectVType);
  const { t } = useTranslation();
  const isGeoDafes = AppTester.isGeoDafes();
  const isGeo = AppTester.isGeograffee();
  const isSuperpuper = AppTester.isSuperPuper();

  const onWhiteBg = isGeoDafes || !isGeo && !isSuperpuper;
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleViewTypeChange = () => {
    // Вычисляем процентное соотношение текущей позиции прокрутки
    const scrollPercent = window.scrollY / document.body.scrollHeight;
    setScrollPosition(scrollPercent);
    const newVType = vtype === LongreadViewType.fluidWide ? LongreadViewType.fluid : LongreadViewType.fluidWide;
    dispatch(setProjectVType(newVType));
  };

  useEffect(() => {
    // Прокрутить страницу до сохраненной процентной позиции
    window.scrollTo(0, scrollPosition * document.body.scrollHeight);
  }, [vtype]);

  if (![LongreadViewType.fluid, LongreadViewType.fluidWide].includes(vtype)) {
    return null
  } 
  const baseStyle = { padding: '2px 8px 4px' };
  const geoStyle = isGeo && !isGeoDafes ? { background: '#353A3E' } : isGeoDafes ? {background: '#E7E7E7', color: '#70706F'} : {};
  const combinedStyle = { ...baseStyle, ...geoStyle };

  return (
    <ViewTypeControllerRoot>
       <HintTooltip 
    // @ts-ignore
    customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={onWhiteBg} text={t('project_edit.view_type.wide')}>
        <LRSwitcherFill
          currentVType={vtype}
          onWhiteBg={onWhiteBg}
          onClick={handleViewTypeChange}
          vtype={LongreadViewType.fluidWide}>
        
              <ViewTypeWide />
        
        </LRSwitcherFill>
      </HintTooltip>
    </ViewTypeControllerRoot>
  );
};

export default memo(ViewTypeControllerWide);
import { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { setProjectVType } from "../../reducers/ViewTypeSlice";
import { FlexBox, HintTooltip } from "@brg/ui";
import { useTranslation } from "react-i18next";
import ViewTypeWide from "../../assets/32/ViewTypeWide";
import { AppTester } from "supporting";

export enum LongreadViewType {
  fluid = 'fluid',
  fluidWide = 'fluid-wide',
  container = "container",
  shadow = "shadow",
}

interface ILRSwitcher {
  vtype?: LongreadViewType;
  currentVType?: LongreadViewType;
  onWhiteBg?: boolean;
}

const LRSwitcherFill = styled.div<ILRSwitcher>`
  cursor: pointer;
  transition: 0.1s;
  //:not(:last-child) {
  //  margin-right: 24px;
  //}
  
  :hover {
    filter: ${({onWhiteBg}) => (!onWhiteBg ? 'brightness(0) invert(1)' : 'brightness(0)')};
  }
  
  filter: ${({ currentVType, vtype, onWhiteBg }) => currentVType === vtype ? (!onWhiteBg ? 'brightness(0) invert(1)' : 'brightness(0)') : 'initial'};
`;

const ViewTypeControllerRoot = styled(FlexBox)`
  height: 100%;
  align-items: center;
  @media (max-width: 2000px) {
    display: none;
  }
`;

const ViewTypeControllerWide = () => {
  const dispatch = useDispatch();
  const vtype = useSelector((state: any) => state.vt.projectVType);
  const { t } = useTranslation();
  const isGeoDafes = AppTester.isGeoDafes();
  const isGeo = AppTester.isGeograffee();
  const isSuperpuper = AppTester.isSuperPuper();

  const onWhiteBg = isGeoDafes || !isGeo && !isSuperpuper;
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleViewTypeChange = () => {
    // Вычисляем процентное соотношение текущей позиции прокрутки
    const scrollPercent = window.scrollY / document.body.scrollHeight;
    setScrollPosition(scrollPercent);
    const newVType = vtype === LongreadViewType.fluidWide ? LongreadViewType.fluid : LongreadViewType.fluidWide;
    dispatch(setProjectVType(newVType));
  };

  useEffect(() => {
    // Прокрутить страницу до сохраненной процентной позиции
    window.scrollTo(0, scrollPosition * document.body.scrollHeight);
  }, [vtype]);

  if (![LongreadViewType.fluid, LongreadViewType.fluidWide].includes(vtype)) {
    return null
  } 
  const baseStyle = { padding: '2px 8px 4px' };
  const geoStyle = isGeo && !isGeoDafes ? { background: '#353A3E' } : isGeoDafes ? {background: '#E7E7E7', color: '#70706F'} : {};
  const combinedStyle = { ...baseStyle, ...geoStyle };

  return (
    <ViewTypeControllerRoot>
       <HintTooltip 
    // @ts-ignore
    customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={onWhiteBg} text={t('project_edit.view_type.wide')}>
        <LRSwitcherFill
          currentVType={vtype}
          onWhiteBg={onWhiteBg}
          onClick={handleViewTypeChange}
          vtype={LongreadViewType.fluidWide}>
        
              <ViewTypeWide />
        
        </LRSwitcherFill>
      </HintTooltip>
    </ViewTypeControllerRoot>
  );
};

export default memo(ViewTypeControllerWide);
